import SimpleSchema from '@boilerplate/lib/simpleSchema';
import { getI18n } from 'react-i18next';

const schema = new SimpleSchema({
        id: {
          type: String,
          optional: true,
          form: false,
          view: true,
        },
        month: {
          type: Date,
          form: {
            component: 'DateTime',
          },
          view: true,
        },
        availability: {
          type: SimpleSchema.Integer,
          form: {
            component: 'Number',
          },
          view: true,
        },
        user: {
          type: String,
          relation: {
            name: 'ManyToOne',
            type: 'ManyToOne',
            model: 'user',
            displayField: 'fullName',
          },
          form: true,
          view: true,
        },
        createdAt: {
          type: Date,
          optional: true,
          form: false,
          view: true,
        },
        updatedAt: {
          type: Date,
          optional: true,
          form: false,
          view: true,
        },
        deletedAt: {
          type: Date,
          optional: true,
          form: false,
          view: true,
        },
});

const { t } = getI18n();
schema.labels({
        id: t(['entityFields:availability.id', 'entityFields:default.id'], '') || undefined,
        month: t(['entityFields:availability.month', 'entityFields:default.month'], '') || undefined,
        availability: t(['entityFields:availability.availability', 'entityFields:default.availability'], '') || undefined,
        user: t(['entityFields:availability.user', 'entityFields:default.user'], '') || undefined,
        createdAt: t(['entityFields:availability.created_at', 'entityFields:default.created_at'], '') || undefined,
        updatedAt: t(['entityFields:availability.updated_at', 'entityFields:default.updated_at'], '') || undefined,
        deletedAt: t(['entityFields:availability.deleted_at', 'entityFields:default.deleted_at'], '') || undefined,
});

export default schema;